import { render, staticRenderFns } from "./VsTabs.vue?vue&type=template&id=1c900b10&scoped=true&lang=html"
import script from "./VsTabs.vue?vue&type=script&lang=js"
export * from "./VsTabs.vue?vue&type=script&lang=js"
import style0 from "./VsTabs.vue?vue&type=style&index=0&id=1c900b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c900b10",
  null
  
)

export default component.exports